import { Tag } from 'antd';
import type { TaskStatus, TaskPriority } from '@/types';

const STATUS_CONFIG: Record<TaskStatus, { label: string; color: string }> = {
  NEW: { label: 'MỚI', color: 'default' },
  ASSIGNED: { label: 'ĐÃ GIAO', color: 'blue' },
  IN_PROGRESS: { label: 'ĐANG LÀM', color: 'gold' },
  PENDING_REVIEW: { label: 'CHỜ DUYỆT', color: 'processing' },
  COMPLETED: { label: 'HOÀN THÀNH', color: 'success' },
  CANCELLED: { label: 'HỦY', color: 'default' },
  OVERDUE: { label: 'QUÁ HẠN', color: 'error' },
  ARCHIVED: { label: 'LƯU TRỮ', color: 'default' },  // V1.0.51
};

const PRIORITY_CONFIG: Record<TaskPriority, { label: string; color: string }> = {
  LOW: { label: 'THẤP', color: 'default' },
  MEDIUM: { label: 'TB', color: 'warning' },
  HIGH: { label: 'CAO', color: 'error' },
  CRITICAL: { label: 'KHẨN', color: 'error' },
};

export function TaskStatusBadge({ status }: { status: TaskStatus }) {
  const cfg = STATUS_CONFIG[status];
  return (
    <Tag color={cfg.color} style={{ fontWeight: 500, fontSize: 11, margin: 0 }}>
      {cfg.label}
    </Tag>
  );
}

export function PriorityBadge({ priority }: { priority: TaskPriority }) {
  const cfg = PRIORITY_CONFIG[priority];
  return (
    <Tag color={cfg.color} style={{ fontWeight: 500, fontSize: 11, margin: 0 }}>
      {cfg.label}
    </Tag>
  );
}
